import React from 'react';
import { navigate } from 'gatsby';
import { FormattedMessage, useIntl } from 'react-intl';
import { AddressFormSubmitButton, CreateAddressView } from '@printdeal/address-frontend';
import { Heading, LinkAsButton } from '@printdeal/ui-library';
import Breadcrumb from '../../../../Breadcrumb';
import Head from '../../../../PrivateHead';

const CreateAddressPage = () => {
  const intl = useIntl();

  return (
    <div className="pd-flex pd-flex-col pd-gap-3">
      <Head title={intl.formatMessage({ id: 'account.addressCreate.title', defaultMessage: 'Create address' })} />
      <Breadcrumb>
        <Breadcrumb.Item to="../..">
          <FormattedMessage id="account.index.title" defaultMessage="My account" />
        </Breadcrumb.Item>
        <Breadcrumb.Item to="..">
          <FormattedMessage id="account.addressList.title" defaultMessage="My addressbook" />
        </Breadcrumb.Item>
        <Breadcrumb.Item isCurrentPage>
          <FormattedMessage id="account.createAddress.title" defaultMessage="Create address" />
        </Breadcrumb.Item>
      </Breadcrumb>

      <Heading as="h2">
        <FormattedMessage id="account.createAddress.title" defaultMessage="Create address" />
      </Heading>

      <CreateAddressView
        onSubmitSuccess={(address) => {
          navigate('..', {
            state: {
              showSuccessAlertForCreatedItem: address.id,
            },
          });
        }}
      />

      <div className="pd-flex pd-items-center pd-justify-between">
        <LinkAsButton
          className="pd-text-sm"
          iconBefore="chevron-left"
          variant="secondary"
          onClick={() => navigate('..')}
        >
          <FormattedMessage id="checkout.backToAddressList" defaultMessage="Back to address list" />
        </LinkAsButton>

        <AddressFormSubmitButton />
      </div>
    </div>
  );
};

export default CreateAddressPage;
